<template>
  <div id="sheba_page">
    <div class="d-flex align-items-center px-3 mb-4">
      <div>
        <span class="h4">حساب بانکی</span>
      </div>
    </div>
    <form @submit.prevent="submitForm" class="px-3">
      <div class="form-group">
        <label for="add_sheba_modal_sheba" class="col-form-label"
        >شماره شبا</label
        >
        <div class="d-flex align-items-center mb-1 text-left" dir="ltr">
          <div class="p-2">
            <span>IR</span>
          </div>
          <input
              type="text"
              dir="ltr"
              class="form-control en_num"
              name="new_sheba"
              v-model="new_sheba"
              id="add_sheba_modal_sheba"
          />
        </div>
      </div>
      <div class="d-flex align-items-center px-3 mt-5">
        <div>
          <button type="button" class="btn btn-success px-4" style="border-radius: 10px" @click="--wizard.current_step">مرحله قبل</button>
        </div>
        <div class="mr-auto">
          <button
              type="submit"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              id="submit_btn"
              :disabled="form_submit_loading"
          >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
              ></span>
            </span>
            <span v-else>مرحله بعد</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { shebaNumberService } from "@/common/api.service";
import { mapGetters } from "vuex";
import $ from "jquery";
import Inputmask from "inputmask";
import IranSheba from "iran-sheba";
import { i18n } from '@/plugins/i18n';

export default {
  name: "sheba",
  props: {
    wizard: Object,
  },
  computed: {
    ...mapGetters("shebaNumber", ["sheba_numbers", "bankAccounts"]),
  },
  mounted() {
    this.$store.dispatch("shebaNumber/fetchBankAccount").then(response => {
      let sheba = this.bankAccounts[0].shebaNumber;

      if (sheba != null && sheba != undefined) {
          this.hasSheba = true;
        this.new_sheba = sheba;
      }
    });
    this.$nextTick(function () {
      setTimeout(() => {
        Inputmask("9999-9999-9999-9999-9999-9999").mask(
            document.querySelectorAll("#add_sheba_modal_sheba")
        );
      }, 1000);
    });
  },
  data() {
    return {
      new_sheba: "",
      form_submit_loading: false,
        hasSheba: false,
    };
  },
  methods: {
    getBankName(sheba) {
      const bank = IranSheba.recognize("IR" + sheba.split("-").join(""));
      if (bank) {
        return bank.persianName;
      }
      return "";
    },
    submitForm(e) {
      if (this.new_sheba == "") return;

      if (this.hasSheba)
          return this.wizard.current_step = 3;

      if (!IranSheba.isValid("IR" + this.new_sheba.split("-").join(""))) {
        let el = $("#sheba_page");
        this.showMsg(el, "danger", i18n.t('validation.invalid_sheba_number'));
        this.new_sheba = "";
        return;
      }

      this.form_submit_loading = true;

      this.$store.dispatch('shebaNumber/createShebaNumebr',{sheba_number: this.new_sheba}).then(response => {
        this.$store.dispatch("shebaNumber/fetch")
        this.wizard.current_step = 3;
      }).catch(({ response }) => {
        let el = $("#sheba_page");
        this.showMsg(el,"danger", response.data.message)
          for (let err in response.data.data) {
            this.showMsg(el,"danger",response.data.data[err][0]);
          }        
      }).finally(() => {
        this.form_submit_loading = false;
      })
    },
    submitHelper(sheba) {
      let el = $("#sheba_page");
      this.form_submit_loading = true;
      shebaNumberService
          .sync({
            params: {
              shebaNumbers: sheba,
            },
          })
          .then((response) => {
            this.wizard.current_step = 3;
          })
          .catch(({ response }) => {
            this.showMsg(el, "danger", response.data.message);
          })
          .finally(() => {
            this.form_submit_loading = false;
          });
    },
  },
};
</script>

<style scoped>
</style>
